class CursorEvent {

	get ENABLE() { return 'enable'; }
	get ENABLE_LEFT() { return 'enable-left'; }
	get ENABLE_RIGHT() { return 'enable-right'; }

	get DISABLE() { return 'disable'; }
	get DISABLE_LEFT() { return 'disable-left'; }
	get DISABLE_RIGHT() { return 'disable-right'; }

	get SHOW() { return 'show'; }
	get HIDE() { return 'hide'; }

	get VIDEO_PAUSE() { return 'videoPause'; }
	get VIDEO_PLAY() { return 'videoPlay'; }

}

export default new CursorEvent();
